<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="services">
        <el-row :gutter="30">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">¿Por qué elegirnos?</h1></el-col>
        </el-row>
        <el-row class="hidden-sm-and-down" :gutter="20">
            <el-col :lg="6">
                <el-card class="box-card">
                    <div class="text item">                          
                        <font-awesome-icon icon="signal" style="font-size:36px;" />            
                        <p class="chevere-text-j small-letter">Productividad, Escalabilidad y Rendimiento son 3 puntos clave que definen nuestro trabajo, nos aseguramos en entregar soluciones óptimas en tiempo récord asegurando que ésta le permita escalar y evolucionar a medida que tus necesidades lo hagan, para que futuras inversiones en mejoras o funcionalidades adicionales no conlleven un impacto económico significativo y así no se vea afectado el rendimiento de tus operaciones</p>
                    </div>
                </el-card>
            </el-col>

            <el-col :lg="6">
                <el-card class="box-card">
                    <div class="text item">                           
                        <font-awesome-icon icon="laptop-code" style="font-size:36px;" />            
                        <p class="chevere-text-j small-letter">Código personalizado, nuestros conocimientos en múltiples plataformas y lenguajes de programación nos permite ofrecerte siempre la mejor alternativa ya sea para un desarrollo nuevo o una integración con un sistema existente, esto también nos permite darte la libertad de tener múltiples opciones sin sacrificar el rendimiento o la funcionalidad de la solución.</p>
                    </div>
                </el-card>
            </el-col>

            <el-col :lg="6">
                <el-card class="box-card">
                    <div class="text item">
                        <font-awesome-icon icon="hands-helping" style="font-size:36px;"  />
                        <p class="chevere-text-j small-letter">Nuestro compromiso es solucionar problemas y satisfacer tus necesidades tecnológicas en cualquier momento, nuestro soporte 24x7 está siempre allí para solucionar cualquier incidencia, con el tiempo de explicarte las tecnologías y ayudarte a tomar las mejores decisiones, nuestros profesionales pueden dictar charlas y capacitaciones in situ y mucho más, nuestro apretón de manos es más que un saludo es un compromiso de apoyarte a cada paso.</p>
                    </div>
                </el-card>
            </el-col>

            <el-col :lg="6">
                <el-card class="box-card">
                    <div class="text item">                            
                        <font-awesome-icon icon="users" style="font-size:36px;"  />
                        <p class="chevere-text-j small-letter">Equipo de profesionales 24x7, nuestro equipo es diverso en áreas de tecnología, siempre entusiastas y dispuestos a poner sus conocimientos a tu disposición y de igual manera con ganas de conocer tus procesos para así ofrecerte todas las mejoras y automatizaciones disponibles </p>
                    </div>
                </el-card>
            </el-col>           
        </el-row>
        <el-row :gutter="20" class="hidden-md-and-up">
            <Carousel   
                    :per-page="1" 
                    :mouse-drag="true"
                    :autoplay="true"
                    :loop="true"
                    :paginationEnabled="false">
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <el-card class="box-card">
                                <div class="text item">                          
                                    <font-awesome-icon icon="signal" style="font-size:36px;" />            
                                    <p class="chevere-text-j small-letter">Productividad, Escalabilidad y Rendimiento son 3 puntos clave que definen nuestro trabajo, siendo productivos nos aseguramos en entregar soluciones óptimas en tiempo récord asegurando que la solución brindada permita escalar y evolucionar a medida que tus necesidades lo hagan asegurando que futuras inversiones en mejoras o funcionalidades adicionales no conlleven un impacto económico significativo y así no se vea afectado el rendimiento de tus operaciones</p>
                                </div>
                            </el-card>
                        </el-col> 
                    </el-row>
                </Slide>
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <el-card class="box-card">
                                <div class="text item">                           
                                    <font-awesome-icon icon="laptop-code" style="font-size:36px;" />            
                                    <p class="chevere-text-j small-letter">Código personalizado para tus necesidades, nuestros conocimientos en múltiples plataformas y lenguajes de programación nos permite ofrecerte siempre la mejor alternativa ya sea para un desarrollo nuevo o una integración con un sistema existente, esto también nos permite darte la libertad de tener múltiples opciones al momento de tomar una decisión sin sacrificar el rendimiento o la funcionalidad de la solución.</p>
                                </div>
                            </el-card>
                        </el-col>   
                    </el-row>
                </Slide>     
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <el-card class="box-card">
                                <div class="text item">                           
                                    <font-awesome-icon icon="hands-helping" style="font-size:36px;"  />
                                    <p class="chevere-text-j small-letter">Dedicados a ayudarte, nuestro compromiso contigo es siempre solucionar tus problemas y satisfacer tus necesidades tecnológicas en cualquier momento, nuestro soporte 24x7 está siempre allí para solucionar cualquier incidencia, nuestros profesionales siempre con el tiempo de explicarte las tecnologías y soluciones en términos de fácil entendimiento para ayudarte a tomar las mejores soluciones, si lo requieres nuestros profesionales pueden dictar charlas y capacitaciones in situ y mucho más, nuestro apretón de manos es más que un saludo es un compromiso de apoyarte a cada paso.</p>
                                </div>
                            </el-card>
                        </el-col>   
                    </el-row>
                </Slide>     
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <el-card class="box-card">
                                <div class="text item">                            
                                    <font-awesome-icon icon="users" style="font-size:36px;"  />
                                    <p class="chevere-text-j small-letter">Equipo de profesionales 24x7, nuestro equipo es diverso en áreas de tecnología, siempre entusiastas y dispuestos a poner sus conocimientos a tu disposición y de igual manera con ganas de conocer tus procesos para así ofrecerte todas las mejoras y automatizaciones disponibles </p>
                                </div>
                            </el-card>  
                        </el-col>   
                    </el-row>
                </Slide>                  
            </Carousel>
        </el-row>
        
    </span>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "Whyus",
    components: {
        Carousel,
        Slide
    }   
}
</script>

<style scoped>    
    .box-card{        
        height: 300px;
        max-height: 300px;
        transition: transform .3s;      
    }
    div .el-card__header{
       padding: 5px !important; 
    }
    .box-card:hover{
        transform: scale(1.05);
    }
    .small-letter{
        font-size: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/sections/Whyus.vue